<template>
  <div class="section container">
    <div class="box">
      <h1 class="title is-primary">I'm John Nguyen</h1>
      <img class="profile" :src="require('../assets/profile.jpg')" />
    </div>
    <div class="box">
      <p>
        I'm a jack of all trades, but especially enjoy projects related to
        music, education, design, and web development.
        <br />
        I've had experiences working with international and local groups in
        projects ranging from branding to editing books.
        <br />
        Look at my portfolio and projects pages to find out more of what I have
        been a part of and the experiences I've had.
      </p>
    </div>
    <div class="box">
      <a
        href="https://www.linkedin.com/in/john-k-nguyen/"
        target="_blank"
        class="button is-link is-rounded has-text-weight-semibold"
        >LinkedIn</a
      >

      <a
        href="https://twitter.com/meetjohnxyz"
        target="_blank"
        class="button is-link is-rounded has-text-weight-semibold"
        >Twitter</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo: {
    title: "Meet John",
    titleTemplate: null,
    meta: [
      { name: "Meet John", content: "Online Portfolio of John Nguyen" },
      { property: "og:title", content: "Meet John" },
      { property: "og:site_name", content: "Meet John" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.meetjohn.xyz" },
      {
        property: "og:image",
        content: "https://meetjohn.xyz/img/profile.2aed145b.jpg"
      },
      {
        property: "og:description",
        content: "Online portfolio of multifaceted creator, John Nguyen"
      },

      {
        name: "twitter:card",
        content: "Online portfolio of multifaceted creator, John Nguyen"
      },
      { name: "twitter:title", content: "Meet John" },
      {
        name: "twitter:description",
        content: "Meet John, a creator and educator"
      },
      {
        name: "twitter:image:src",
        content: "https://meetjohn.xyz/img/profile.2aed145b.jpg"
      },

      { itemprop: "name", content: "Meet John" },
      {
        itemprop: "description",
        content: "Online portfolio of multifaceted creator, John Nguyen"
      },
      {
        itemprop: "image",
        content: "https://meetjohn.xyz/img/profile.2aed145b.jpg"
      }
    ],
    link: [{ rel: "canonical", href: "https://www.meetjohn.xyz" }]
  }
};
</script>

<style lang="scss">
.box {
  padding-top: 15rem;
  padding-bottom: 10rem;
}
.profile {
  height: 30rem;
  width: 30rem;
}
.button {
  margin: 1rem;
}
@media only screen and (max-width: 768px) {
  .profile {
    height: 15rem;
    width: 15rem;
  }
}
</style>
